import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { FormattedDateTime } from '@10xLabs/react-web/components/FormattedDateTime'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from 'components/v2/Table'
import { useLogin } from 'features/Login/hooks'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canWrite } from 'features/Users/utils'
import { GTBookingClass } from 'gql/types.generated'
import { BookingClassesActions } from './Actions'

export const BookingClassesList = ({ bookingClasses = [] }: { bookingClasses: GTBookingClass[] }): ReactElement => {
  const intl = useIntl()
  const login = useLogin()

  return (
    <TableContainer overflow>
      <Table marginBottom>
        <Thead>
          <Tr>
            {canWrite(FEATURES.BOOKING_CLASS, login.accessToken.policies) && <Th />}
            <Th>
              <FormattedMessage id="dictionary.name" defaultMessage="Name" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.activatedAt" defaultMessage="Activated at" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.updatedAt" defaultMessage="Updated at" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.priority" defaultMessage="Priority" />
            </Th>
            <Th>
              <FormattedMessage id="dictionary.company" defaultMessage="Company" />
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {bookingClasses.map((bookingClass): TSFixMe => {
            return (
              <Tr key={bookingClass.id}>
                {canWrite(FEATURES.BOOKING_CLASS, login.accessToken.policies) && (
                  <Td>
                    <BookingClassesActions bookingClass={bookingClass} />
                  </Td>
                )}
                <Td>{bookingClass.name}</Td>
                <Td>
                  {bookingClass.activatedAt ? <FormattedDateTime date={bookingClass.activatedAt} intl={intl} /> : 'N/A'}
                </Td>
                <Td>{bookingClass.updatedAt && <FormattedDateTime date={bookingClass.updatedAt} intl={intl} />}</Td>
                <Td>{bookingClass.priority}</Td>
                <Td>{bookingClass.company.name}</Td>
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
